import { useBoardsSectionModel } from './useBoardsSectionModel.js'
import BoardsSectionView from './BoardsSectionView.jsx'

export default function BoardsSection(props) {
  return <BoardsSectionView {...useBoardsSectionModel(props)} />
}
